var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427321452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 160610",
    d: "M0 12.4286C0 8.01032 3.58172 4.42859 8 4.42859H18.8657C23.2839 4.42859 26.8657 8.01031 26.8657 12.4286V23C26.8657 27.4183 23.284 31 18.8657 31H8C3.58173 31 0 27.4183 0 23V12.4286Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 160611",
    d: "M16.5672 6.64286C16.5672 2.97411 19.5413 0 23.21 0H23.3571C27.0259 0 30 2.97411 30 6.64286C30 10.3116 27.0259 13.2857 23.3571 13.2857H23.21C19.5413 13.2857 16.5672 10.3116 16.5672 6.64286Z",
    fill: "#FDB62F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSp);
export default __webpack_public_path__ + "static/media/sp.515d4fca4007e05f17d90553be2ca5bb.svg";
export { ForwardRef as ReactComponent };